import { createFileRoute, Navigate } from '@tanstack/react-router'
import { UsageAndCost } from '../../../components'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

export const Route = createFileRoute('/_layout/analytics/usage-and-cost')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <UsageAndCost />
            </RoleRestrictedContent>
        </>
    )
}
